import * as React from "react";
import { useState, useEffect } from "react";
import cafeLogo from "../../../assets/cafe/logo_cafe_white.svg";
import styles from "./styles.js";
import api from "../../services/api";
import { storeUserData, clearStoredUserData, retrieveStoredData } from "../../store/authContext";
/* global require */
let ui;
Office.onReady(function () {
  ui = Office.context.ui;
});

// update to use the api and handle the localhost/shibboleth case
const urlBase = ((window.APP_CONFIG && window.APP_CONFIG.apiBaseUrl) || "https://d.mconf.rnp.br").replace(/\/+$/, "");
// const urlBase = "http://localhost:3000";
const urlPath = "/users/shibboleth?outlook=true";
const url = urlBase + urlPath;

// Keep these logs so we can ask users to see the console if they are using on the web
// and handle errors based on their userAgent
let browser;
console.log('Browser');
if (navigator.userAgent.indexOf("Trident") !== -1) {
  console.log("Trident");
  browser = "trident";
} else if (navigator.userAgent.indexOf("Trident") !== -1) {
  console.log("Edge");
  browser = "edge";
} else {
  console.log("Other");
  browser = "other";
}

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const data = retrieveStoredData();
    if (data) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleShibbLogin = () => {
    // Open as a popup (not a tab) so window.opener is preserved across redirects
    window.open(url, "shibboleth_login", "width=600,height=700,scrollbars=yes,resizable=yes");
  };

  // get user data from API response
  async function receiveMessage(event) {
    if (!event.data || !event.data.params) return;
    const { email, name, slug, token } = event.data.params;
    if (event.source) event.source.close();
    storeUserData(slug, `Bearer ${token}`);
    setIsLoggedIn(true);
  }

  useEffect(() => {
    window.addEventListener("message", receiveMessage);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);

  const handleLogout = () => {
    api
      .delete("/api/v2/users/logout")
      .then(() => {
        clearStoredUserData();
      })
      .catch((err) => {
        clearStoredUserData();
        console.log(err);
      });
    setIsLoggedIn(false);
  };

  const LoginScreen = () => {
    return (
      <div style={styles.topLeft}>
        <div style={styles.leftModalTop}>
          <img style={styles.logoStyle} src={cafeLogo} alt="cafeLogo" />
        </div>
        <div style={styles.leftModalBottom}>
          <div style={styles.topHead}>
            <h1 style={styles.headerConferencia}>Acesso Federado</h1>
            <h3 style={styles.cardContentConferencia}>Já tenho uma conta</h3>
          </div>
          <button style={styles.loginButton} onClick={handleShibbLogin}>
            Entrar
          </button>
        </div>
      </div>
    )
  }

  // TODO: Make it into a component when we add more functions
  const MenuScreen = () => {
    return (
      <button style={styles.loginButton} onClick={handleLogout}>
        Sair
      </button>
    );
  }

  const OldBrowserScreen = () => {
    return (
      <div style={styles.explorerCard}>
          <h2 style={styles.headerConferencia}>Ops...</h2>
          <h4 style={styles.cardContentConferencia}>
            Este plugin não é suportado pela versão do aplicativo que você está utilizando.
            Para garantir a melhor experiência, recomendamos que você utilize uma versão mais atual ou a versão web.
          </h4>
        </div>
    );
  }

  return (
    <div>
      {browser == 'trident' ? (
        OldBrowserScreen()
      ) : (
        <div style={styles.body}>
          {!isLoggedIn ? (LoginScreen()) : (MenuScreen())}
        </div>
      )}
    </div>
  );
};
export default App;
